import Box from '@mui/material/Box';

import Card from '../../../components/Card';
import Loading from '../../../components/Loading';

import MarketNews from './MarketNews';
import * as Styles from '../Dashboard.styles';

export default function MarketNewsSection({ isMarketNewsLoading, marketNews }) {
  return (
    <div className="grid gap-6 grid-cols-1 slg:grid-cols-3 mt-6">
      <Card title="Thị trường chứng khoán thế giới">
        <div className="mt-6 relative">
          {isMarketNewsLoading ? <Styles.EmptyTag /> : null}
          <Loading isLoading={isMarketNewsLoading} className="white" />
          {!isMarketNewsLoading ? (
            <>
              {!marketNews?.nasdaq100?.changePercent &&
              !marketNews?.nasdaq100?.price &&
              !marketNews?.nasdaq100?.change &&
              !marketNews?.dowJones?.changePercent &&
              !marketNews?.dowJones?.price &&
              !marketNews?.dowJones?.change &&
              !marketNews?.sp500?.price &&
              !marketNews?.sp500?.price &&
              !marketNews?.sp500?.changePercent ? (
                <Box>Không có dữ liệu</Box>
              ) : (
                <>
                  <MarketNews
                    name={marketNews?.nasdaq100?.name}
                    price={marketNews?.nasdaq100?.price}
                    change={marketNews?.nasdaq100?.change}
                    changePercent={marketNews?.nasdaq100?.changePercent}
                    date={marketNews?.nasdaq100?.date}
                    source={marketNews?.nasdaq100?.source}
                  />
                  <MarketNews
                    name={marketNews?.dowJones?.name}
                    price={marketNews?.dowJones?.price}
                    change={marketNews?.dowJones?.change}
                    changePercent={marketNews?.dowJones?.changePercent}
                    date={marketNews?.dowJones?.date}
                    source={marketNews?.dowJones?.source}
                    variant="withoutPrice"
                  />
                  <MarketNews
                    name={marketNews?.sp500?.name}
                    price={marketNews?.sp500?.price}
                    change={marketNews?.sp500?.change}
                    changePercent={marketNews?.sp500?.changePercent}
                    date={marketNews?.sp500?.date}
                    source={marketNews?.sp500?.source}
                    variant="withoutPrice"
                  />
                </>
              )}
            </>
          ) : null}
        </div>
      </Card>
      <Card title="Thị trường hàng hóa">
        <div className="mt-6 relative">
          {isMarketNewsLoading ? <Styles.EmptyTag /> : null}
          <Loading isLoading={isMarketNewsLoading} className="white" />
          {!isMarketNewsLoading ? (
            <>
              {!marketNews?.goldPrice?.changePercent &&
              !marketNews?.goldPrice?.price &&
              !marketNews?.goldPrice?.change &&
              !marketNews?.usCrudeOil?.changePercent &&
              !marketNews?.usCrudeOil?.price &&
              !marketNews?.usCrudeOil?.change &&
              !marketNews?.brentCrudeOil?.changePercent &&
              !marketNews?.brentCrudeOil?.price &&
              !marketNews?.brentCrudeOil?.change ? (
                <Box>Không có dữ liệu</Box>
              ) : (
                <>
                  <MarketNews
                    name={marketNews?.goldPrice?.name}
                    price={marketNews?.goldPrice?.price}
                    change={marketNews?.goldPrice?.change}
                    changePercent={marketNews?.goldPrice?.changePercent}
                    date={marketNews?.goldPrice?.date}
                    source={marketNews?.goldPrice?.source}
                  />
                  <MarketNews
                    name={marketNews?.usCrudeOil?.name}
                    price={marketNews?.usCrudeOil?.price}
                    change={marketNews?.usCrudeOil?.change}
                    changePercent={marketNews?.usCrudeOil?.changePercent}
                    date={marketNews?.usCrudeOil?.date}
                    source={marketNews?.usCrudeOil?.source}
                  />
                  <MarketNews
                    name={marketNews?.brentCrudeOil?.name}
                    price={marketNews?.brentCrudeOil?.price}
                    change={marketNews?.brentCrudeOil?.change}
                    changePercent={marketNews?.brentCrudeOil?.changePercent}
                    date={marketNews?.brentCrudeOil?.date}
                    source={marketNews?.brentCrudeOil?.source}
                  />
                </>
              )}
            </>
          ) : null}
        </div>
      </Card>
      <Card title="Hợp đồng Tương Lai">
        <div className="mt-6 relative">
          {isMarketNewsLoading ? <Styles.EmptyTag /> : null}
          <Loading isLoading={isMarketNewsLoading} className="white" />
          {!isMarketNewsLoading ? (
            <>
              {!marketNews?.urea?.changePercent &&
              !marketNews?.urea?.price &&
              !marketNews?.urea?.changePercent &&
              !marketNews?.rubber?.price &&
              !marketNews?.rubber?.change &&
              !marketNews?.rubber?.changePercent ? (
                <Box>Không có dữ liệu</Box>
              ) : (
                <>
                  <MarketNews
                    name={marketNews?.urea?.name}
                    price={marketNews?.urea?.price}
                    change={marketNews?.urea?.change}
                    changePercent={marketNews?.urea?.changePercent}
                    date={marketNews?.urea?.date}
                    source={marketNews?.urea?.source}
                  />
                  <MarketNews
                    name={marketNews?.rubber?.name}
                    price={marketNews?.rubber?.price}
                    change={marketNews?.rubber?.change}
                    changePercent={marketNews?.rubber?.changePercent}
                    date={marketNews?.rubber?.date}
                    source={marketNews?.rubber?.source}
                  />
                </>
              )}
            </>
          ) : null}
        </div>
      </Card>
    </div>
  );
}
